import axios from "axios";
import { Logger } from "@nestjs/common";

import {
  IPageableRechargeOrderResponse,
  IRechargeOrder,
  IRechargeOrderGetParams,
  ISingleRechargeOrderResponse,
} from "../../model/RechargeOrder";
import { RechargeResourceEndpoint } from "../../RechargeEndpoint";
import { RechargeAccessTokenManager } from "../RechargeAccessTokenManager";

export class RechargeOrdersClient extends RechargeResourceEndpoint<
ISingleRechargeOrderResponse,
IPageableRechargeOrderResponse,
IRechargeOrderGetParams,
IRechargeOrder
> {

  public constructor(
    rechargeKeyManager: RechargeAccessTokenManager,
    baseUrl = "https://api.rechargeapps.com",
  ) {
    super(
      axios.create({ baseURL: baseUrl }),
      rechargeKeyManager.getNextAccessToken.bind(rechargeKeyManager),
      "/orders",
      new Logger(RechargeOrdersClient.name),
    );
  }

  protected override singleGetter(t: ISingleRechargeOrderResponse): IRechargeOrder {
    return t.order;
  }

  protected override multiGetter(t: IPageableRechargeOrderResponse): IRechargeOrder[] {
    return t.orders;
  }

}
